import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'

HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

export function recommendChartInit(_seriesData, spMark) {
    //data
    drawRecommendChart('recommend_chart',_seriesData, spMark);
}

export function drawRecommendChart(divId, lineData, spMark){
    // Same order and colors as the rank badges (.b_E2E.top ... .seven) in the legend
    var seriesColors = ['#EAB308', '#A8A29E', '#D97706', '#10B981', '#3B82F6', '#7C3AED', '#FB7185']

    let seriesData = [];

    if(lineData.series != null) {
        for(let i = 0; i < lineData.series.length; i++){
            let series = {
                data: lineData.series[i].data,
                pointPlacement: 'on',
                animation: false,
                lineWidth: 2,
                color: seriesColors[i],
                zIndex: 7 - i,
                marker:{
                    radius: 4,
                    symbol: 'circle',
                    states: {
                        hover: {
                            radius: 5.4
                        },
                        select: {
                            radius: 5.4
                        }
                    }
                },
                states: {
                    inactive: {
                        opacity: 1
                    }
                }
            }
            seriesData.push(series);
        }
    }

    var analysisOption = {
        credits: {
            enabled: false,
        },
        accessibility: {
            enabled: false
        },
        // Figma: 450x510, rank rows 60px apart (1st row at y=30, 圏外 at y=450), grid x=34..424
        chart: {
            backgroundColor: 'transparent',
            type: 'line',
            height: 510,
            width: 450,
            marginTop: -30,
            marginBottom: 60,
            marginLeft: 34,
            marginRight: 26,
            events: {
                load: function () {
                    // Figma: first point 6px inside the grid, last point 10px inside (PC) / 8px (SP)
                    padXAxis(this, 6, spMark == 'sp' ? 8 : 10);
                }
            }
        },
        title: {
            text: ''
        },
        tooltip: {
          enabled: false
        },
        xAxis: {
            title: {
                text: ''
            },
            categories: lineData.categories,
            tickmarkPlacement: 'on',
            lineWidth: 0,
            gridLineWidth: 0,
            labels: {
                useHTML: true,
                autoRotation: false,
                formatter: function () {
                    if (this.isLast) {
                        return this.value + '<span style="display:block; font-size:12px; color:#64748b; font-weight:normal;">直近</span>';
                    }
                    return this.value;
                },
                style: {
                    fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#334155',
                    textOverflow: 'clip',
                    textAlign: 'center',
                    lineHeight: '1.5'
                },
                // Figma: label top 18px below the 圏外 line (PC)
                y: 28
            }
        },
        yAxis: {
            title: {
                text: null
            },
            gridLineColor: "#CBD5E1",
            gridLineWidth: 1,
            lineWidth: 0,
            min: 0,
            tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            reversed: true,
            labels: {
                enabled: true,
                useHTML: true,
                formatter: function() {
                    if (this.value === 0) return '';
                    if (this.value === 8) return '圏外';
                    return String(this.value);
                },
                align: 'right',
                x: -8,
                style: {
                    fontFamily: "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
                    fontSize: '12px',
                    fontWeight: 'normal',
                    color: '#64748b'
                }
            }
        },
        legend: {
            enabled: false
        },
        pane: {
            size: '73%'
        },
        series: seriesData
    };

    var spWidth = $(window).width();

    if(spMark == 'sp') {
        // Figma SP: same rows as PC, fluid width, grid ends 8px from the right edge
        analysisOption.chart.width = null;
        analysisOption.chart.marginRight = 8;
        // Figma SP: label top 10.5px below the 圏外 line
        analysisOption.xAxis.labels.y = 20.5;
    }

    var recommendChart = Highcharts.chart(divId, analysisOption);

    $(window).on('resize', function () {
        recommendChart.reflow();
    })
}

function padXAxis(chart, leftPx, rightPx) {
    var axis = chart.xAxis[0];
    var lastIndex = axis.categories.length - 1;
    var step = (chart.plotWidth - leftPx - rightPx) / lastIndex;
    axis.setExtremes(-leftPx / step, lastIndex + rightPx / step, true, false);
}

export default { recommendChartInit, drawRecommendChart };